import React from 'react';

function Contactos() {
    return (
        <div>
            <h1>Contactos</h1>
            <p>Este componente está temporalmente deshabilitado. Use ContactosV3 en su lugar.</p>
        </div>
    );
}

export default Contactos;